 <ng-container *ngIf="canAccess; else forbidden">
<div class="page">



  <!-- SEARCH CARD -->
  <mat-card class="card search-card">
    <mat-card-header>
      <mat-card-title>
        <div class="card-title">
          Search for Consents
        </div>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>

      <form [formGroup]="form" (ngSubmit)="listRecords()" class="search-form">

        <mat-form-field appearance="outline" class="search-field">
          <!-- <mat-label>Enter search term...</mat-label> -->
          <input matInput formControlName="searchValue" placeholder="Enter search term..." (input)="transformToLowercase($event)">

          <!-- <button mat-icon-button matSuffix disabled *ngIf="isLoading">
            <mat-icon class="rotate">sync</mat-icon>
          </button> -->
          <mat-hint *ngIf="matchLevel">
            Detected Type: <strong>{{ matchLevel }}</strong>
          </mat-hint>
        </mat-form-field>

        <div class="buttons">
          <button mat-raised-button extended color="primary" type="submit" [disabled]="isLoading">
             <mat-icon class="rotate" *ngIf="isLoading">sync</mat-icon>
            Search
          </button>

          <!-- <button mat-stroked-button color="warn" type="button" (click)="reset()">
            Limpar
          </button> -->
        </div>

      </form>

      <!-- Info -->
      <div class="info-box">
        <strong>You can search for:</strong>
        <ul>
          <li>client codes</li>
          <li>policy codes</li>
          <li>phone numbers*</li>
          <li>e-mail addresses*</li>
        </ul>
        <div class="note">
          * Searching for these values will only return the exact match, and not any related contact methods.
          Search for a client or policy code to see all options for a customer.
        </div>
      </div>


    </mat-card-content>
  </mat-card>

  <div class="contact-container">

    <mat-card class="card results-card" *ngIf="policyHolder">

      <mat-card-header>
        <mat-card-title>
          <div class="card-title">
            {{ policyHolder.PolicyHolderName }}
          </div>
        </mat-card-title>
      </mat-card-header>


      <mat-card-content>
        <app-policy-holder-details [policyHolder]="policyHolder"></app-policy-holder-details>
      </mat-card-content>



    </mat-card>

    <!-- CURRENT CONSENT CARD -->
    <mat-card class="card results-card" *ngIf="listCurrentStatus!.length > 0">
      <mat-card-header>
        <mat-card-title>
          <div class="card-title">
            <span>Current Status</span>
            <div class="action-container" *ngIf="hasChangedItems">
              <button class="undo-btn" mat-raised-button extended [disabled]="isSaving" color="primary" type="button"
                (click)="undoChanges()">
                Undo Changes
              </button>

              <button mat-raised-button class="save-btn" [disabled]="isSaving" (click)="saveChanges()">
                <span>Save</span>
                <mat-icon *ngIf="isSaving" class="spin">autorenew</mat-icon>
              </button>
            </div>
          </div>

        </mat-card-title>
      </mat-card-header>
      <hr>
      <mat-card-content>
        <div class="current-consent-container">

          <div class="channel-container">

            <div class="channel-item" *ngFor="let item of listCurrentStatus">

              <div class="channel">
                <span class="channel-icon material-icons"
                  [ngClass]="{green: !item.IsOptOut && item.consentMissing != true, red: item.IsOptOut  && item.consentMissing != true, gray: item.consentMissing}">
                  {{ getChannelIcon(item.Channel) }}
                </span>
                {{item.Channel}}
              </div>

              <div class="value">{{item.Value}}</div>

              <div class="slider-container">
                <mat-slide-toggle color="primary" labelPosition="before" *ngIf="!item.consentMissing"
                  [(ngModel)]="item.IsOptOut" checked="item.IsOptOut"><span
                    [ngClass]="{green: !item.IsOptOut , red: item.IsOptOut}">{{item.IsOptOut ? 'Opted Out' : 'Opted In'}}</span></mat-slide-toggle>
              </div>


              <button mat-raised-button extended (click)="addConsent(item.Channel, item.Value)"
                *ngIf="item.consentMissing">Enable</button>


            </div>
          </div>

        </div>
      </mat-card-content>

    </mat-card>
  </div>

  <!-- RESULT CARD -->
  <mat-card class="card results-card" *ngIf="listUserTrackConsent!.length > 0">

    <mat-card-header>
      <mat-card-title>
        <div class="card-title">
          History ({{ listUserTrackConsent.length }})
        </div>
      </mat-card-title>
    </mat-card-header>


    <mat-card-content>
      <div class="results-container">
        <app-consent-timeline [userTrackerConsents]="listUserTrackConsent" [viewMode]="'timeline'">
        </app-consent-timeline>
      </div>
    </mat-card-content>



  </mat-card>

  <app-no-record-found *ngIf="enableNoRecordsFound"></app-no-record-found>

</div>

 </ng-container>

  <ng-template #forbidden>
      <app-forbidden-page />
    </ng-template>

